import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { LoggingService } from './logging.service';
import { NotifierService } from 'angular-notifier';
import { Router } from '@angular/router';
import { VersionCheckService } from '../core/services/version-check.service';



@Injectable({ providedIn: 'root' })
export class LoginService {

  localInfo: any = JSON.parse(localStorage.getItem('access'));
  public loginBtnControl:any = {"btnOff":true,"btnLogin":false,"loginPassword":false,"loginOtp":false,"hideOtpResend":true,"showOtpResend":false,"isUnKnownUser":false}
  public interval:number = 60;
  public intervalCall:any;
  public onPopopLoginEvent = new EventEmitter<any>();
  public isPopupLoginOpened: boolean = false;
  public setSideDrowerEvent = new EventEmitter<any>();
  public unKnownUserText: string = "This email is not registered.";
  public termandCondType:string = '';

  constructor(private http: HttpClient, private log: LoggingService, private notifier: NotifierService, private versionCheckService: VersionCheckService) { 
    this.loginBtnControl = {"btnOff":true,"btnLogin":false,"loginPassword":false,"loginOtp":false,"hideOtpResend":true,"showOtpResend":false,"isUnKnownUser":false};
  }

  loginPassword(username: string, password: string) {
    const httpPostOptions =    {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      withCredentials: true
    };
    // let opt = {};
    // opt['httpOptions'] = httpPostOptions;
    // return this.apiRequest.request('POST','/v2/users/session',{ email: username, password: password },opt)
    // .pipe(map(data => {
    //   let _data:any = data;
    //   if (_data['message'] === 'Success') {
    //     localStorage.setItem('access', JSON.stringify(_data['userDetails']));
    //   }
    //   return _data;
    // }));
    return this.http.post<any>(environment.apiUrl + `/v2/users/session`, { email: username, password: password }, httpPostOptions)
      .pipe(map(data => {
        if (data.message === 'Success') {
          localStorage.setItem('access', JSON.stringify(data.userDetails));
          // Check for new version immediately after successful login
          this.versionCheckService.checkVersionOnLogin();
        }
        return data;
      }));
  }
  OtpRequest(username) {
    const httpPostOptions =    {
      headers:new HttpHeaders().set('Content-Type', 'application/json'),
      withCredentials: true
    }
    // let opt = {};
    // opt['httpOptions'] = httpPostOptions;
    // return this.apiRequest.request('POST','/v2/users/send-otp',{ email: username },opt)
    // .subscribe(data => 
    //   {
    //     let _data:any = data;
    //      return _data['message'];
    //   }
    // )
    this.http.post<any>(environment.apiUrl + `/v2/users/send-otp`, { email: username }, httpPostOptions)
    .subscribe(data => 
      { 
        if(data.status == 0){
          this.notifier.notify('error', data.message);
        }
        return data.message;
      }
    )
  }


  

  // verfiyUser(username,source) {
  //   const httpPostOptions =    {
  //     headers:new HttpHeaders().set('Content-Type', 'application/json'),
  //     withCredentials: true
  //   } 
  //   this.http.post<any>(environment.apiUrl + `/v2/users/verfiy-user`, { email: username }, httpPostOptions)
  //   .subscribe(data => 
  //     { 
  //       console.log("login data is ===> ",data);
  //       if (data.status == 1) {
  //         if (source === "loginPassword") {
  //           this.loginBtnControl.btnOff=false;
  //           this.loginBtnControl.btnLogin=true;
  //           this.loginBtnControl.loginPassword=true;
  //           this.loginBtnControl.loginOtp=false;
  //           this.loginBtnControl.hideOtpResend=true;
  //           this.loginBtnControl.showOtpResend=false;
  //           this.loginBtnControl.isUnKnownUser=false;
  //         }else{
  //           this.loginBtnControl.btnOff=false;
  //           this.loginBtnControl.btnLogin=true;
  //           this.loginBtnControl.loginPassword=false;
  //           this.loginBtnControl.loginOtp=true;
  //           this.OtpRequest(username);
  //           this.loginBtnControl.hideOtpResend=true;
  //           this.loginBtnControl.showOtpResend=false;
  //           clearInterval(this.intervalCall);
  //           this.interval = 60;
  //           this.intervalCall = setInterval(()=>{
  //             if(this.interval > 0){
  //               this.interval = this.interval - 1;
  //             }else{
  //               clearInterval(this.intervalCall);
  //               this.loginBtnControl.hideOtpResend = false;
  //               this.loginBtnControl.showOtpResend = true;
  //             }
  //           }, 1000);
  //           this.loginBtnControl.isUnKnownUser=false;
  //         }
  //       }else if (data.status == 2) {
  //         this.loginBtnControl.btnOff=true;
  //         this.loginBtnControl.btnLogin=false;
  //         this.loginBtnControl.loginPassword=false;
  //         this.loginBtnControl.loginOtp=false;
  //         this.loginBtnControl.hideOtpResend=true;
  //         this.loginBtnControl.showOtpResend=false;
  //         this.loginBtnControl.isUnKnownUser=true;
  //         this.unKnownUserText = data.message;
  //       } else{
  //         this.loginBtnControl.btnOff=true;
  //         this.loginBtnControl.btnLogin=false;
  //         this.loginBtnControl.loginPassword=false;
  //         this.loginBtnControl.loginOtp=false;
  //         this.loginBtnControl.hideOtpResend=true;
  //         this.loginBtnControl.showOtpResend=false;
  //         this.loginBtnControl.isUnKnownUser=true;
  //         this.unKnownUserText = "This email is not registered.";
  //         this.notifier.notify('error', this.unKnownUserText);
  //       }
  //       return data.message;
  //     }
  //   )
  // }

   verfiyUser(username,source) {
    const httpPostOptions =    {
      headers:new HttpHeaders().set('Content-Type', 'application/json'),
      withCredentials: true
    } 
    this.http.post<any>(environment.apiUrl + `/v2/users/verfiy-user`, { email: username }, httpPostOptions)
      .subscribe({next: data => 
        { 
          // console.log("login data is ===> ",data);
          if (data.status == 1) {
            if (source === "loginPassword") {
              this.loginBtnControl.btnOff=false;
              this.loginBtnControl.btnLogin=true;
              this.loginBtnControl.loginPassword=true;
              this.loginBtnControl.loginOtp=false;
              this.loginBtnControl.hideOtpResend=true;
              this.loginBtnControl.showOtpResend=false;
              this.loginBtnControl.isUnKnownUser=false;
            }else{
              this.loginBtnControl.btnOff=false;
              this.loginBtnControl.btnLogin=true;
              this.loginBtnControl.loginPassword=false;
              this.loginBtnControl.loginOtp=true;
              this.OtpRequest(username);
              this.loginBtnControl.hideOtpResend=true;
              this.loginBtnControl.showOtpResend=false;
              clearInterval(this.intervalCall);
              this.interval = 60;
              this.intervalCall = setInterval(()=>{
                if(this.interval > 0){
                  this.interval = this.interval - 1;
                }else{
                  clearInterval(this.intervalCall);
                  this.loginBtnControl.hideOtpResend = false;
                  this.loginBtnControl.showOtpResend = true;
                }
              }, 1000);
              this.loginBtnControl.isUnKnownUser=false;
            }
          }else if (data.status == 2) {
            this.loginBtnControl.btnOff=true;
            this.loginBtnControl.btnLogin=false;
            this.loginBtnControl.loginPassword=false;
            this.loginBtnControl.loginOtp=false;
            this.loginBtnControl.hideOtpResend=true;
            this.loginBtnControl.showOtpResend=false;
            this.loginBtnControl.isUnKnownUser=true;
            this.unKnownUserText = data.message;
          } else{
            this.loginBtnControl.btnOff=true;
            this.loginBtnControl.btnLogin=false;
            this.loginBtnControl.loginPassword=false;
            this.loginBtnControl.loginOtp=false;
            this.loginBtnControl.hideOtpResend=true;
            this.loginBtnControl.showOtpResend=false;
            this.loginBtnControl.isUnKnownUser=true;
            this.unKnownUserText = "This email is not registered.";
            this.notifier.notify('error', this.unKnownUserText);
          }
          return data.message;
        },
        error: (error) => {
          // console.log("verfiyUser error is ===> ",error);
          if (error.status === 429) {
            this.loginBtnControl.btnOff=true;
            this.loginBtnControl.btnLogin=false;
            this.loginBtnControl.loginPassword=false;
            this.loginBtnControl.loginOtp=false;
            this.loginBtnControl.hideOtpResend=true;
            this.loginBtnControl.showOtpResend=false;
            this.loginBtnControl.isUnKnownUser=true;
            this.unKnownUserText = error.error.message;
            this.notifier.notify('error', this.unKnownUserText);
          } 
        }
      })
  }
 




  
  loginOtp(username: string, otp: string) {
    const httpPostOptions =    {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      withCredentials: true
    };
    return this.http.post<any>(environment.apiUrl + `/v2/users/session/otp`, { email: username, otp: otp }, httpPostOptions)
      .pipe(map(data => {
        if (data.message === 'Success') {
          localStorage.setItem('access', JSON.stringify(data.userDetails));
          // Check for new version immediately after successful OTP login
          this.versionCheckService.checkVersionOnLogin();
        }
        return data;
      }));
  }

  loginStart() {
    if (this.localInfo != null) {
      this.localInfo = JSON.parse(localStorage.getItem('access'));
      return this.localInfo;
    }    else {
      return 'no login';
    }
  }

  logout() {
    this.log.logInfo(environment.apiUrl + `/v2/users/logout`);
    // remove user from local storage to log user out
    localStorage.removeItem('access');
    this.clearLocalStorageEmail();
    // return this.apiRequest.request('GET','/v2/users/logout')
    //   .pipe(map(data => {
    //     let _data:any = data;
    //     return _data;
    //   }));
    return this.http.get<any>(environment.apiUrl + `/v2/users/logout`)
      .pipe(map(data => {
        return data;
      }));
  }

  clearLocalStorageEmail() {
    let userMail = localStorage.getItem('user_login_email');
    if(userMail) {
      localStorage.removeItem('user_login_email');
    }
  }

  isSessionLoggedOut() {
    const httpPostOptions =    {
      headers:new HttpHeaders().set('Content-Type', 'application/json'),
      withCredentials: true
    }
    return this.http.get<any>(environment.apiUrl + '/v2/api/globalsearch?parameter=test', httpPostOptions);
  }

  navValidate() {



  }

  getTermAndCond(){
    const httpPostOptions =    {
      headers:new HttpHeaders().set('Content-Type', 'application/json'),
      withCredentials: true
    }
    return this.http.get<any>(environment.apiUrl + '/api/termConditionCheck', httpPostOptions)

  }

  acceptTnc(status:String,type:string){
    const httpPostOptions =    {
      headers:new HttpHeaders().set('Content-Type', 'application/json'),
      withCredentials: true
    }
    return this.http.post<any>(environment.apiUrl + `/api/saveTermStatus`, {status:status,type:type}, httpPostOptions)
  
  }



}
